import { memo } from 'react';
import { Button } from '@heroui/react';
import { Certificate } from '@/entities/Certificates';
import { Svg } from '@/shared/ui/Svg';
import TrashIcon from '@/shared/assets/icons/trash.svg';
import DownloadIcon from '@/shared/assets/icons/download.svg';

interface CertificatesSelectedActionsProps {
  selectedRows: Certificate[];
  onSaveSelected?: () => void;
  /** Не передан — кнопка скрыта (нет права на удаление) */
  onDeleteSelected?: () => void;
  isDeleting?: boolean;
  isDownloading?: boolean;
}

export const CertificatesSelectedActions = memo(
  ({
    selectedRows,
    onSaveSelected,
    onDeleteSelected,
    isDeleting,
    isDownloading,
  }: CertificatesSelectedActionsProps) => {
    if (selectedRows.length === 0) {
      return null;
    }

    return (
      <div className="flex items-center gap-4">
        <span className="text-grey-secondary">Selected: {selectedRows.length}</span>
        {onSaveSelected && (
          <Button
            className="border-[#211D55] bg-white text-[#211D55]"
            onPress={onSaveSelected}
            isLoading={isDownloading}
            isDisabled={isDownloading}
            endContent={<Svg Icon={DownloadIcon} width={20} height={20} />}
          >
            Save ({selectedRows.length})
          </Button>
        )}
        {onDeleteSelected && (
          <Button
            className="border-red-tertiary bg-white text-red-tertiary"
            onPress={onDeleteSelected}
            isLoading={isDeleting}
            endContent={<Svg Icon={TrashIcon} width={20} height={20} />}
          >
            Delete ({selectedRows.length})
          </Button>
        )}
      </div>
    );
  },
);

CertificatesSelectedActions.displayName = 'CertificatesSelectedActions';
